// Single point of Firebase app initialization.
// Guard against re-initialization during HMR in development.

import { initializeApp, getApps, type FirebaseApp } from 'firebase/app'
import { firebaseConfig } from './config'

const app: FirebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : (getApps()[0] as FirebaseApp)

export { app }
